import { useState } from "react";
import { faqs } from "@/mocks/homeData";
import SectionHeading from "@/components/base/SectionHeading";

export default function Faq() {
  const [openId, setOpenId] = useState<string>("");

  const toggle = (id: string) => setOpenId((prev) => (prev === id ? "" : id));

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto max-w-3xl">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题"
          desc="关于内容范围、更新频率与浏览方式，这里集中回答浏览者最常提出的问题。"
        />

        <div className="mt-10 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100">
          {faqs.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div key={item.id}>
                <button
                  type="button"
                  onClick={() => toggle(item.id)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-200/50"
                >
                  <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                    {item.q}
                  </span>
                  <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-background-50 text-primary-600">
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                  </span>
                </button>
                {isOpen ? (
                  <div className="animate-fadeIn px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}